import { Channel } from 'src/app/models/channel';

export const DEFAULT_MESSENGER_CHANNEL: Channel = {
    type: 'messenger',
    displayName: 'Messenger',
    status: 'inactive'
}

export const DEFAULT_TWITTER_CHANNEL: Channel = {
    type: 'twitter',
    displayName: 'Twitter DM',
    status: 'inactive'
}